import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/HIW1.png";
import HIW2img from "images/HIW2.png";
import HIW3img from "images/HIW3.png";
import VectorImg from "images/VectorHIW.svg";

export interface CookiesProps {
  className?: string;
}

const Cookies: FC<CookiesProps> = ({ className = "pt-6 pb-6" }) => {
  return (
    <div className="flex items-center justify-center flex-col bg-[#E5E5E5] pt-6 pb-6 ">
      <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-black justify-center">
        Gestion des cookies
      </h2>

      <div className="rounded-xl">
        <div className="flex flex-col justify-center items-center pt-5">
          <div className="flex items-stretch p-6 mb-4 max-w-4xl bg-white rounded-lg border border-gray-200 shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div className="flex flex-col justify-between">
              <p className="mb-2 font-semibold text-gray-900 dark:text-white">Qu’est-ce qu’un cookie ?</p>
              <p className="h-full">
                Un cookie, également appelé traceur, est un petit fichier texte qui est stocké sur l’appareil de
                l’utilisateur (ordinateur, smartphone, tablette ou tout autre appareil connecté à Internet) lors de
                sa visite sur un site web. Certains cookies restent enregistrés sur cet appareil pendant une
                certaine période et sont réactivés à chaque nouvelle visite de l’utilisateur sur le site.
              </p>
              <p className="mb-2 font-semibold text-gray-900 dark:text-white">
                Utilisation des cookies obligatoires
              </p>

              <p className="h-full">
                Sur notre site, nous utilisons uniquement les cookies strictement nécessaires au bon fonctionnement
                du site. Ces cookies obligatoires permettent, par exemple, de gérer la connexion, la navigation
                entre les pages, ou encore la sécurisation des sessions. Aucun cookie destiné à la publicité, au
                suivi ou à la collecte de données personnelles n’est utilisé sans le consentement préalable de
                l’utilisateur.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
